/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import SectionVo from './SectionVo';




  /**
   * The LessonVo model module.
   * @module textbook/model/LessonVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>LessonVo</code>.
   * @alias module:textbook/model/LessonVo
   * @class
   */
  var exports = function() {
    var _this = this;











  };

  /**
   * Constructs a <code>LessonVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/LessonVo} obj Optional instance to populate.
   * @return {module:textbook/model/LessonVo} The populated <code>LessonVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'unitId')) {
        obj['unitId'] = ApiClient.convertToType(data['unitId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'serialName')) {
        obj['serialName'] = ApiClient.convertToType(data['serialName'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'filePath')) {
        obj['filePath'] = ApiClient.convertToType(data['filePath'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'fileUrl')) {
        obj['fileUrl'] = ApiClient.convertToType(data['fileUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'html')) {
        obj['html'] = ApiClient.convertToType(data['html'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'wordCount')) {
        obj['wordCount'] = ApiClient.convertToType(data['wordCount'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'targetTime')) {
        obj['targetTime'] = ApiClient.convertToType(data['targetTime'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sectionList')) {
        obj['sectionList'] = ApiClient.convertToType(data['sectionList'], [SectionVo]);
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 单元id
   * @member {Integer} unitId
   */
  exports.prototype['unitId'] = undefined;
  /**
   * 编号名
   * @member {String} serialName
   */
  exports.prototype['serialName'] = undefined;
  /**
   * 名称
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 文件路径名称
   * @member {String} filePath
   */
  exports.prototype['filePath'] = undefined;
  /**
   * 文件url
   * @member {String} fileUrl
   */
  exports.prototype['fileUrl'] = undefined;
  /**
   * html源码
   * @member {String} html
   */
  exports.prototype['html'] = undefined;
  /**
   * 字数
   * @member {String} wordCount
   */
  exports.prototype['wordCount'] = undefined;
  /**
   * 目标学习时间毫秒
   * @member {Integer} targetTime
   */
  exports.prototype['targetTime'] = undefined;
  /**
   * 仅在toc api中返回
   * @member {Array.<module:textbook/model/SectionVo>} sectionList
   */
  exports.prototype['sectionList'] = undefined;



  export default exports;
;


